import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  //STAGING MVP
  // baseUrl = 'https://hubadminapi.ncpl.bigcityvoucher.co.in/v1';

  //prod

   baseUrl ='https://hubadminapi.npclrewards.in/v1'

  login = this.baseUrl + '/hubadmin/log-in';
  logout = this.baseUrl + '/hubadmin/logout';

  //company
  getCompanylist = this.baseUrl + '/hubadmin/list-company';
  addCompany = this.baseUrl + '/hubadmin/add-company';
  editCompany = this.baseUrl + '/hubadmin/edit-company';
  deleteCompany = this.baseUrl + '/hubadmin/deactivate-company';
  generateId = this.baseUrl + '/hubadmin/generate-id';

  orderDetails = this.baseUrl + '/client/getordercumulative';

  // Rewards Categoreies
  getListRewardCategory = this.baseUrl + '/hubadmin/list-product-cats';
  addRewardCategory = this.baseUrl + '/hubadmin/add-product-cats';
  editRewardCategory = this.baseUrl + '/hubadmin/edit-product-cats';

  // Reporting Panel
  enrollmentReport = this.baseUrl + 'report-dashboard/new-enrollment-report';
  identityReport =
    this.baseUrl + 'report-dashboard/identity-verification-report';
  accountVerificationReport =
    this.baseUrl + 'report-dashboard/account-verification-report';

    //  Reward window
  getDisableStatus = this.baseUrl + "/hubadmin/get-reward-window-configuration?program_id=1"
  updateRewardsStatus = this.baseUrl + '/hubadmin/update-reward-window-configuration?program_id=1'
  // Rewards Products add

  getRewardsProductsList = this.baseUrl + '/hubadmin/list-product';
  getCategories = this.baseUrl + '/hubadmin/list-product-cats';
  uploadBulkProducts = this.baseUrl + '/hubadmin/product-excel-upload';
  disableProduct = this.baseUrl + '/hubadmin/active-deactive';
  editProduct = this.baseUrl + '/hubadmin/edit-product';
  upload_my_rewards = this.baseUrl + '/scratch-cards/import-scratch-card';
  create_reward_brand = this.baseUrl + '/rewards/create-reward-brands';
  get_reward_brand = this.baseUrl + '/rewards/get-reward-brands';
  update_reward_brand = this.baseUrl + '/rewards/update-reward-brands';
  delete_reward_brand = this.baseUrl + '/rewards/delete-reward-brands';
  uploadRewardsCategories = this.baseUrl + '/rewards/import-reward-category?';
  uploadRewardsSubCategories =
    this.baseUrl + '/rewards/import-reward-sub-category?';
  uploadRewardBrands = this.baseUrl + '/rewards/import-reward-brands?';

  //Qualifier-configuration
  getQualifiers = this.baseUrl + '/qualifier/get-qualifier?program_id=1';
  creatQualifiers = this.baseUrl + '/qualifier/create-qualifier?program_id=1';
  editQualifiers = this.baseUrl + '/qualifier/update-qualifier?program_id=1';
  deleteQualifiers = this.baseUrl + '/qualifier/delete-qualifier?program_id=1';

  //programns

  addPrograms = this.baseUrl + '/hubadmin/add-programs';
  editPrograms = this.baseUrl + '/hubadmin/edit-programs';
  listPrograms = this.baseUrl + '/hubadmin/list-programs';
  deactivateProgram = this.baseUrl + '/hubadmin/deactivate-programs';

  // Product Category

  addCategory = this.baseUrl + '/hubadmin/add-product-cats';
  editCategory = this.baseUrl + '/hubadmin/edit-product-cats';
  listCategory = this.baseUrl + '/hubadmin/list-product-cats';
  deactivateCategory = this.baseUrl + '/hubadmin/deactivate-product-cats';

  //variation-masters
  addVariationMas = this.baseUrl + '/hubadmin/add-variation-mas';
  listVariationMas = this.baseUrl + '/hubadmin/list-variation-mas';

  // variation
  addVariation = this.baseUrl + '/hubadmin/add-variation';
  listVariation = this.baseUrl + '/hubadmin/list-variation';

  // Products
  uploadProductFile = this.baseUrl + '/hubadmin/product-excel-upload';

  addProducts = this.baseUrl + '/hubadmin/add-product';

  // /Products-variation
  uploadProductVarFile = this.baseUrl + '/hubadmin/product-variation-upload';

  // ListOFProducts
  ListOfProducts = this.baseUrl + '/hubadmin/list-product';
  editProducts = this.baseUrl + '/hubadmin/edit-product';
  deleteDenomination = this.baseUrl + '/hubadmin/disable-denomination';

  //delivery partner
  getdelPartnerList = this.baseUrl + '/delivery-partner/get-partner?';

  //Redemption Panel
  getOrderList = this.baseUrl + '/redemption/order-listing?';
  getListProgram = this.baseUrl + '/hubadmin/list-programs';
  uploadEGVOrderStatus = this.baseUrl + '/redemption/order-offer-code-upload';
  uploadPhysiaclOrderStatus = this.baseUrl + '/redemption/order-statusupload';
  rejectDropdown = this.baseUrl + '/redemption/rejection-reason'; // rejected reason
  approveRejectOrder = this.baseUrl + '/redemption/approve-rejectby-bcp';
  deliveryPartner = this.baseUrl + '/redemption/delivery-partner';
  dashboard_report =
    this.baseUrl + '/report-dashboard/report-dashboard?program_id=1';

  changeOrderStatusByForm =
    this.baseUrl + '/ops-panel/bulk-status-update?program_id=1';
  changeOrderStatusByeExcel =
    this.baseUrl + '/ops-panel/order-statusupload?program_id=1';
  getDownOrderExlData = this.baseUrl + '/ops-panel/get-orderexcel';
  getCancelReasonDropDown =
    this.baseUrl + '/ops-panel/get-order-cancelling-reason';

  getVoucherCodes = this.baseUrl + '/redemption/offercode';

  // Reverse Points
  ReversePoints = this.baseUrl + '/redemption/reversal-panel';
  RedemptionReversePoint = this.baseUrl + '/redemption/reverse-point';
  // physical reward
  downloadEgvRewards = this.baseUrl + '/redemption/egv-summary';
  downloadPhysicalRewardExcel = this.baseUrl + '/redemption/order-summary';
  orderStatus = this.baseUrl + '/redemption/readorderstatus';
  deliveryPatner = this.baseUrl + '/redemption/delivery-partner';
  storeStatus = this.baseUrl + '/redemption/setorderstatus';

  //Finance
  getProformaInvoice = this.baseUrl + '/client/getperforma?';
  approveSingleInvoice =
    this.baseUrl + '/client/setapprovalstatus?new_approval_status=2';
  downloadSingleInvoice = this.baseUrl + '/finance/proforma-download?';
  uploadInvoiceStatus = this.baseUrl + '/hubadmin/upload-invoice?program_id=1';
  getInvoiceList = this.baseUrl + '/hubadmin/list-invoice?';
  getServiceInvoiceList =
    this.baseUrl +
    '/finance/list-service-profoma?service_pi_status=2&invoice_flag=1';
  generatePI = this.baseUrl + '/finance/generate-proforma?program_id=1';
  verifyInvoice = this.baseUrl + '/hubadmin/verify-invoice?invoice_id=';
  updateInvoiceStatus = this.baseUrl + '/finance/update-invoice-status';
  downloadProofZip =
    this.baseUrl + '/client/download-invoice-proofs?invoice_id=';
  deliverOrders = this.baseUrl + '/finance/delivered-orders';
  servicesPI = this.baseUrl + '/finance/service-profoma?program_id=1';
  getServicePI =
    this.baseUrl +
    '/finance/list-service-profoma?service_pi_status=2&invoice_flag=';
  getServicePII =
    this.baseUrl +
    '/finance/list-service-profoma?service_pi_status=1&invoice_flag=';

    uploadServicePayment = this.baseUrl + "/finance/upload-service-payment?program_id=1"
  uploadPayment = this.baseUrl + '/finance/upload-service-payment';
  uploadInvoiceService = this.baseUrl + '/finance/upload-invoice-service?program_id=1';
  getRejectionReason = this.baseUrl + '/redemption/rejection-reason';
    getAuthrizedOrderList = this.baseUrl + "/redemption/list-authentication-orders?";
      orderListStats = this.baseUrl + "/redemption/statistics"
        dashboardDetails = this.baseUrl + '/client/dashboard'
          piForm = this.baseUrl + "/finance/list-proforma-form";
    approveServiceProfoma = this.baseUrl + "/finance/approve-service-profoma?program_id=1"
      catalogueReport = this.baseUrl + '/report/sku-report'
        loginReport = this.baseUrl + '/report/login-report'
          cancellationReport = this.baseUrl + '/report/cancellation-report' 
            deductionReport = this.baseUrl + '/report/deduction-report'
  uploadInvoiceStatuss = this.baseUrl + '/client/setpaymentstatus?program_id=1';
  //Agent Panel
  getAgentOrderList = this.baseUrl + '/report/customer-orders?';
  getSingleRedemptionInfo = this.baseUrl + '/redemption/offercode';
  getAgentOldOrdersList = this.baseUrl + '/report/old-redemptions';
  getRedemptiondetails = this.baseUrl + '/redemption/redemption-data';

  //Visibility /get-posm-config
  getVisibilityList =
    this.baseUrl + '/visibility/get-posm-elements?program_id=1';
  addVisibility = this.baseUrl + '/visibility/create-posm-elements';
  editVisibility = this.baseUrl + '/visibility/update-posm-elements';
  deleteVisibility = this.baseUrl + '/visibility/delete-posm-elements';
  saveVisibilityConfig = this.baseUrl + '/visibility/create-posm-config';
  getVisibilityConfig =
    this.baseUrl + '/visibility/get-posm-config?program_id=1';
  updateVisibilityConfig = this.baseUrl + '/visibility/update-posm-config';
  getVisibilitySubmittedList =
    this.baseUrl + '/visibility/get-posm-audit-transactions?page=';
  visibilityApproveOrReject =
    this.baseUrl + '/visibility/posm-audit-approve-reject';
  getPosmOnChannel =
    this.baseUrl +
    '/visibility/get-channel-posm-elements?program_id=1&channel_id=';
  // Units
  configGetUnit = this.baseUrl + '/units/get-units';
  configAddUnit = this.baseUrl + '/units/create-unit';
  configEditUnit = this.baseUrl + '/units/update-unit?id=';

  // targetUserFilter =
  getTargetAchivementList = this.baseUrl + '/loyalty-target/get-targets';
  updateTargetAchivement = this.baseUrl + '/loyalty-target/update-target';
  addTargetAchivement = this.baseUrl + '/loyalty-target/create-target';
  configGetStates = this.baseUrl + '/state/get-state?program_id=1';

  // Instant Voucher Upload
  uploadInstantVoucher = this.baseUrl + '/rewards/instant-voucher-upload';
  getInstantVoucherCodes = this.baseUrl + '/rewards/list-instant-product';
  my_rewards_list = this.baseUrl + '/scratch-cards/scratch-card-headers';
  //Schemes
  getSchemes = this.baseUrl + '/scheme/get-scheme';
  addSchemes = this.baseUrl + '/scheme/create-scheme-data';
  getSchemeConfig = this.baseUrl + '/scheme/get-scheme?id=';
  getSchemeProductCategory = this.baseUrl + '/scheme/get-brand-category';
  extendScheme = this.baseUrl + '/scheme/update-scheme-date?id=';
  getSchemeConfigSettings = this.baseUrl + '/';
  updateScheme = this.baseUrl + '/scheme/update-scheme?id=';
  downloadSchemeUserExcel =
    this.baseUrl + '/scheme/download-users?program_id=1';

  uploadSchemeUserExcel = this.baseUrl + '/users/intermediate-user';
  getSpinWheels = this.baseUrl + '/spin-wheel/list-spin-config?id=';

  //ROLES
  // OLD API
  configGetRoles = this.baseUrl + '/user-role/get-user-roles';
  // NEW
  getRoles = this.baseUrl + '/user-role/get-role';
  downloadUserExcel = this.baseUrl + '/users/download-user-excel?program_id=1';
  // Balance Check

  getAmozonWoohoBalance =
    this.baseUrl +
    '/common/check-balance?&secret_key=$2y$10$z0ihWtyW2HsEAh1VMNbGUOXKN1w9RJo8Vgwb6PLCsQLU.F2OcVU5W';

  //
  filterDataParams = this.baseUrl + 'course/get-course?program_id=1';

  //qr-reports
  getQrReport = this.baseUrl + 'report-dashboard/generate-qr-report';

  //Reports
  enrollmentReports = this.baseUrl + 'outlet-reports/export-enrollment-users';
  twoTimeRejectedReport = this.baseUrl + 'outlet-reports/admin-rejected-report';
  engagementReports = this.baseUrl + 'engagement-report';
  regionWiseReports =
    this.baseUrl + 'outlet-reports/export-region-wise-targets';
  targetsVsAchievedReports =
    this.baseUrl + 'outlet-reports/export-target-vs-achieved';
  regionWisePoints = this.baseUrl + 'outlet-reports/outlet-points';
  pointBalanceReport = this.baseUrl + 'outlet-reports/point-balance-report';
  redemptionReport = this.baseUrl + 'outlet-reports/redemption-report';
  topTenReport = this.baseUrl + 'outlet-reports/export-target-achieved-rank';
  outletWiseInvoiceReport =
    this.baseUrl + 'outlet-reports/export-outlet-wise-invoice-report';
  categoryWiseAchivementReport =
    this.baseUrl + 'outlet-reports/export-product-category-wise-achievement';
  ordersReport = this.baseUrl + 'outlet-reports/ecommerce-order-report';
  schemeReport = this.baseUrl + 'outlet-reports/scheme-report';
  //downloadSelectedUsersList = this.baseUrl2 + "users/download-userdata";

  accountReport = this.baseUrl + '/report/account-summary-report?program_id=1';
  feedbackReport = this.baseUrl + '/report/feedback-report?program_id=1';
  redemptionSummaryReport =
    this.baseUrl + '/report/redemption-summary-report?program_id=1';

  // **********************************

  // Cumulative reports
  cumulativeEnrollmentReports =
    this.baseUrl + '/cumulative-reports/cumulative-enrollment-report';
  cumulativePointBalanceReport =
    this.baseUrl + '/cumulative-reports/point-balance-report';
  cumulativeOrdersReport = this.baseUrl + '/cumulative-reports/order-report';
  cumulativeEngagementReport =
    this.baseUrl + '/cumulative-reports/engagement-report';
  //***REWARDS***//

  //** Point Balance Report */

  //reward category
  getRewardCategories = this.baseUrl + '/rewards/get-reward-category';
  addRewardCategories = this.baseUrl + '/rewards/create-reward-category';
  editRewardCategories = this.baseUrl + '/rewards/update-reward-category';
  deleteRewardCategories = this.baseUrl + '/rewards/delete-reward-category';
  rewardHistory = this.baseUrl + '/rewards/get-reward-orders';
  getRewardProducts = this.baseUrl + '/rewards/get-reward-products';
  getRewardProductbyId = this.baseUrl + '/rewards/get-reward-products&id=';
  createRewardProducts = this.baseUrl + '/rewards/create-reward-products';
  updateRewardProducts = this.baseUrl + '/rewards/update-reward-products';
  deleteRewardProducts = this.baseUrl + '/rewards/delete-reward-products';

  //reward sub category

  getRewardSubCategories = this.baseUrl + '/rewards/get-reward-subcategory';
  addRewardSubCategories = this.baseUrl + '/rewards/create-reward-subcategory';
  editRewardSubCategories = this.baseUrl + '/rewards/update-reward-subcategory';
  deleteRewardSubCategories =
    this.baseUrl + '/rewards/delete-reward-subcategory';

  //Reward Type

  getRewardType = this.baseUrl + '/reward-type/get-reward-types';
  addRewardType = this.baseUrl + '/reward-type/create-reward-type?id=1';
  editRewardType = this.baseUrl + '/reward-type/update-reward-type?id=';
  deleteRewardType = this.baseUrl + '/reward-type/update-reward-type?id=';

  // Engagement API
  engagementCreateActivity =
    this.baseUrl + '/engagement/create-campaign-activity';
  engagementUpdate = this.baseUrl + '/engagement/update-task?id=';
  getAllEngagement = this.baseUrl + '/engagement/get-engagements';
  createEngagementTask = this.baseUrl + '/engagement/create-task';
  getUserAssignment = this.baseUrl + '/user-modules/get-all-whitelisted-user';
  getSchemeUsers = this.baseUrl + '/user-modules/get-all-whitelisted-userids';
  getUsersFilter = this.baseUrl + '/users/search-users-by-filter';
  getQuizDetails = this.baseUrl + '/engagement/get-quiz-activities?';
  assignUserDetails = this.baseUrl + '/engagement/assign-user-task';
  createQuizEngage = this.baseUrl + '/engagement/create-quiz';
  updateQuizEngage = this.baseUrl + '/engagement/update-quiz?id=';
  createpointsConfig =
    this.baseUrl + '/engagement/create-engagement-point-structure';
  getEngagementTaskPoints =
    this.baseUrl + '/engagement/engagement-point-structure?task_id=';
  getAssignedUsers = this.baseUrl + '/engagement/get-user-tasks?task_id=';
  uploadImages = this.baseUrl + '/engagement/upload-img';
  adhoc = this.baseUrl + '/ops-panel/adhoc-userpoints';

  /**
   * Activity
   */
  campaign_activites = this.baseUrl + '/engagement/get-campaign-activites';
  createActivity = this.baseUrl + '/engagement/create-campaign-activity';

  //for update messageTemplate was using updateActivity
  //updateActivity = this.baseUrl + "/engagement/update-campaign-activity?id=";
  //getActivityBasedOnTask =this.baseUrl + "/engagement/get-campaign-activites?campaign_id=";

  //orders

  getAllOrders = this.baseUrl + '/ecommerce/get-ecommerce-orders';
  getOrderDetails = this.baseUrl + '/ecommerce/view-ecommerce-order?id=';
  orderApproveReject = this.baseUrl + '/ecommerce/accept-reject-order';
  getAllCategiry = this.baseUrl + '/ecommerce/get-ecommerce-categories';
  createCatgory = this.baseUrl + '/ecommerce/create-ecommerce-categories';
  updateCategory = this.baseUrl + '/ecommerce/update-ecommerce-categories';

  //***REWARDS***//
  getAllOffers = this.baseUrl + '/ecommerce/loaddata-for-offer-details';
  //Schemes

  //Visibility /get-posm-config

  getShelfConditions = this.baseUrl + '/visibility/get-shelves-cooler-purity';
  getShelfConditionsForSubmission =
    this.baseUrl + '/visibility/get-shelves-points&posm_master_config=';

  //campaign

  getAllCampaign = this.baseUrl + '/campaign/get-campaigns';
  addCampaign = this.baseUrl + '/campaign/create-campaign';
  editCampaign = this.baseUrl + '/campaign/update-campaign';
  deleteCampaign = this.baseUrl + '/campaign/delete-campaign';

  //* GEOGRAPHY *//
  getAllGeographies = this.baseUrl + '/geographical/get-geographs';
  addGeography = this.baseUrl + '/geographical/create-geography';
  editGeography = this.baseUrl + '/geographical/update-geography?id=';

  //ecommerce
  getProductsList = this.baseUrl + '/product/listallproducts';
  getProductById = this.baseUrl + '/product/editproduct&product_id=';
  getProductDelete = this.baseUrl + '/product/deleteproduct';
  addToProductList = this.baseUrl + '/product/addnewproduts';
  getProductCategories = this.baseUrl + '/ecommerce/get-ecommerce-categories';
  updateProduct = this.baseUrl + '/product/updateproduct';
  createGeography = this.baseUrl + '/geographical/create-geography';
  getProductVarient = this.baseUrl + '/product/get-product-variants';
  getProductVarientValues =
    this.baseUrl + '/product/get-product-variant-values?product_variant_id=';
  createOfferDetails = this.baseUrl + '/ecommerce/create-offer-details';
  getOfferDetails = this.baseUrl + '/ecommerce/get-offer-details&offer_id=';

  //****carton Insert****//
  getCartonList = this.baseUrl + '/tertiary-programs/get-cartons';

  getCampaignsList = this.baseUrl + '/carton-insert/campaigns-list';
  getProductBrand = this.baseUrl + '/carton-insert/get-products';
  createCartonCampaign = this.baseUrl + '/carton-insert/create-carton-campaign';
  CartonCampaignDetail = this.baseUrl + '/carton-insert/get-campaigns-details';
  updateCartonCapmpaign =
    this.baseUrl + '/carton-insert/update-carton-campaign';
  generateQRCarton = this.baseUrl + '/carton-insert/qr-code-generation-api';
  cartonQrlist = this.baseUrl + '/carton-insert/qr-code-list';
  cartonQrDownload = this.baseUrl + '/carton-insert/download-qr-codes';
  cartonAssignUser = this.baseUrl + '/carton-insert/whitelist-users';
  uploadUserByExl = this.baseUrl + '/carton-insert/upload-whitelist-users';
  CartonWhiteList = this.baseUrl + '/carton-insert/get-whitelist-users';
  pointConfigurationUpload = this.baseUrl + '/carton-insert/points-structure';
  pointConfigurationList = this.baseUrl + '/carton-insert/get-points-structure';
  cartonUploadTarget = this.baseUrl + '/carton-insert/upload-targets';
  CartonTargetList = this.baseUrl + '/carton-insert/get-targets-list';
  specialOcceranceList =
    this.baseUrl + '/carton-insert/get-special-points-structure';
  specialOcceranceUpload =
    this.baseUrl + '/carton-insert/special-points-structure';

  /**
   * Content & learning
   */
  getContenentAndLearning =
    this.baseUrl + '/content-learning/get-course&course_id=';
  getTaskTypes = this.baseUrl + '/content-learning/course-type';
  courseCreation = this.baseUrl + '/content-learning/create-course';
  courseUserAssign = this.baseUrl + '/content-learning/map-course-users';
  updateContentAndLearning = this.baseUrl + '/content-learning/update-course';
  deleteContentAndLearning = this.baseUrl + '/content-learning/delete-course';
  createCourseQuiz = this.baseUrl + '/content-learning/create-quiz';
  updateCourseQuiz = this.baseUrl + '/content-learning/update-quiz';
  deleteCourseQuiz = this.baseUrl + '/content-learning/delete-quiz';
  getAllCourseQuiz = this.baseUrl + '/content-learning/get-quiz&course_id=';
  getContentAndLearningMappedUser =
    this.baseUrl + '/content-learning/mapped-course-user-lists';

  /**
   * Visit tracker
   */
  newEnrollmentHeaders = this.baseUrl + '/users/get-userenrollment-headers';
  getVisits = this.baseUrl + '/visit-tracker/get-visits';
  createVisits = this.baseUrl + '/visit-tracker/create-visits';
  getVisitEnrollment = this.baseUrl + '/visit-tracker/get-enrollments';
  approveRejectEnroll =
    this.baseUrl + '/visit-tracker/approve-reject-enrollment';
  approveRejectEnrollNew = this.baseUrl + '/users/approve-reject-enrollment';
  saveScheme = this.baseUrl + '/scheme/create-scheme-data';
  createEnroll = this.baseUrl + '/visit-tracker/create-enrollment';
  getOfferById = this.baseUrl + '/ecommerce/edit-offers&';

  // Influncers
  getEncryptionCodes = this.baseUrl + '/scan-earn/get-scanner-detail';
  uploadInfluencerQR = this.baseUrl + '/users/upload-scanner';

  uploadBulkInfluencerQR = this.baseUrl + '/users/upload-influencers-qr';
  downloadZipFileQRCode = this.baseUrl + '/users/genrate-influencers-qr';

  /****/
  // targetUserFilter =
  assignedLoyaltyTarget = this.baseUrl + '/loyalty-target/get-loyalty-targets';
  createOffer = this.baseUrl + '/ecommerce/create-offers';
  deleteOffer = this.baseUrl + '/ecommerce/delete-offers';
  updateOffer = this.baseUrl + '/ecommerce/update-offers';
  createWhitelist = this.baseUrl + '/user-modules/create-user-module';
  getModule = this.baseUrl + '/module/get-modules';
  getUserModules = this.baseUrl + '/user-modules/get-user-modules';
  createLoyalty = this.baseUrl + '/loyalty-target/add-target-point-structure';
  getAssignedUser = this.baseUrl + '/loyalty-target/get-assigned-users';
  getLoyaltyTargets = this.baseUrl + '/loyalty-target/get-loyalty-targets';
  getPointStructure = this.baseUrl + '/points-structure/get-points-structure';
  updateLoyaltyTarget = this.baseUrl + '/loyalty-target/update-loyalty-target';
  updatePointsTarget =
    this.baseUrl + '/points-structure/update-points-structure';
  downloadTargetFile = this.baseUrl + '/loyalty-target/download-target-details';
  downloadAchievementExcel =
    this.baseUrl + '/loyalty-target/download-achievement-target';
  /**Excel section */
  uploadMultiProducts = this.baseUrl + '/product/upload-products';
  uploadMultiRewards = this.baseUrl + '/rewards/create-reward-products-excel';
  createSalesAchivement = this.baseUrl + '/loyalty-target/create-achievements';
  getSalesAchivements =
    this.baseUrl + '/loyalty-target/get-loyalty-achievements';
  updateSalesAchievement =
    this.baseUrl + '/loyalty-target/update-loyalty-achievement';
  approveSalesAchievement =
    this.baseUrl + '/loyalty-target/approve-sales-achievements';
  filterByCity = this.baseUrl + '/city/filter-city';
  productUploadExcelFields = this.baseUrl + '/product/product-upload-fields';
  getReardProductsWithPagination =
    this.baseUrl + '/rewards/get-reward-products-filter?';
  getAllLoyaltyTargetsMapping =
    this.baseUrl +
    '/loyalty-target/get-loyalty-target-general-mapping?target_id=';
  getAllParentRolls = this.baseUrl + '/user-role/parentroles';
  getAllModules = this.baseUrl + '/user-modules/get-modules-lists';
  getRollProfileList = this.baseUrl + '/user-role/profiles';
  getRollTypes = this.baseUrl + '/user-role/roletypes';
  getTargetListBasedOnPage =
    this.baseUrl +
    '/loyalty-target/get-loyalty-target-general-mapping?target_id=';
  getPointListBasedOnPage =
    this.baseUrl +
    '/loyalty-target/get-loyalty-point-general-mapping?target_id=';
  createBrandTargets_general =
    this.baseUrl + '/loyalty-target/create-loyalty-general-setting';
  getHierarchyLevel_roles = this.baseUrl + '/user-role/role-hierarchy';
  excel_upload_targetsDetails =
    this.baseUrl + '/loyalty-target/update-loyalty-targets';
  update_targets_for_sku =
    this.baseUrl +
    '/loyalty-target/update-loyalty-general-setting-with-products?id=';
  setTarget_points_for_sku =
    this.baseUrl + '/loyalty-target/create-loyalty-points-setting';
  createArchivements_excelUpload =
    this.baseUrl + '/loyalty-target/create-achievements';
  getArchivement_list = this.baseUrl + '/loyalty-target/get-achievements-list';
  generateCheckerAndMaker =
    this.baseUrl + '/loyalty-target/create-achievement-report';
  makerCheckerForScheme = this.baseUrl + '/scheme/schemeverification';
  downloadSchemeExcel =
    this.baseUrl + '/scheme/scheme-excel-achievement?achivement_id=';
  uploadNewSchemeMakerData =
    this.baseUrl + '/scheme/scheme-maker-checker-transactions';
  approveSchemeMakerChecker =
    this.baseUrl + '/scheme/scheme-approve-reject-achievement';
  getGeneratedCheckerAndMaker =
    this.baseUrl + '/loyalty-target/get-achievement-report';
  getDownloadReport = this.baseUrl + '/loyalty-target/get-excel-achievement&';
  approveReport = this.baseUrl + '/loyalty-target/approve-reject-achievement';
  modifyCheckerAndMakerPoints =
    this.baseUrl + '/loyalty-target/maker-checker-transactions';
  brandsExcelHeaders = this.baseUrl + '/brands/brand-upload-fields';
  brandsExcelUpload = this.baseUrl + '/brands/upload-brands';
  deleteTarget = this.baseUrl + '/loyalty-target/delete-targets';
  getTargetPointBrands = this.baseUrl + '/brands/get-brand';
  getUserTargetPoints =
    this.baseUrl + '/loyalty-target/user-targets-points?target_id=';
  getUserTargets =
    this.baseUrl + '/loyalty-target/get-users-targets?target_id=';
  getUserPoints = this.baseUrl + '/loyalty-target/get-users-points?target_id=';
  getEngementDetailsForEdit =
    this.baseUrl + '/engagement/get-engagementbyid?eng_id=';
  getBrandCategoryHeaders =
    this.baseUrl + '/brand-category/excel-brand-category-headers';
  uploadExcelDataBrandCategory =
    this.baseUrl + '/brand-category/upload-brand-category';
  uploadExcelForTargets = this.baseUrl + '/loyalty-target/upload-target-points';
  downloadExcelForTargets =
    this.baseUrl + '/loyalty-target/get-excel-target-sku';
  get_all_rewards_products = this.baseUrl + '/reward/productlisthome';
  getPointStructureOnID = this.baseUrl + '/loyalty-target/get-pointstructure';

  getbrands = this.baseUrl + '/loyalty-target/get-brands-by-portfolio';

  // generateMakerCheckerReport = this.baseUrl + "/loyalty-target/salesmakerchecker";

  // generatedReportsList = this.baseUrl + "/loyalty-target/list-maker-check";
  // generatePointsMakerChecker = this.baseUrl + "/loyalty-target/maker-checker";
  // getApprovePointsMakerChecker = this.baseUrl + "/loyalty-target/finalpointsmakercheckerupload";
  // uploadArropvedExcel = this.baseUrl + "/loyalty-target/upload-points";
  // rejectPoints = this.baseUrl + "/loyalty-target/reject-points";

  // Latest Maker checker report
  generateMakerCheckerReport =
    this.baseUrl + '/loyalty-target/salesmakerchecker';
  generatedReportsList = this.baseUrl + '/loyalty-target/list-maker-check';
  generatePointsMakerChecker = this.baseUrl + '/loyalty-target/maker-checker';
  getApprovePointsMakerChecker =
    this.baseUrl + '/loyalty-target/finalpointsmakercheckerupload';
  uploadArropvedExcel = this.baseUrl + '/loyalty-target/upload-points';
  rejectPoints = this.baseUrl + '/loyalty-target/reject-points';
  getTargetImports = this.baseUrl + '/loyalty-target/get-target-import';
  rejectuserPoints = this.baseUrl + '/loyalty-target/reject-points';

  // Points Structure
  createPointsStructure =
    this.baseUrl + '/loyalty-target/create-point-config-template';
  getPointsStructure =
    this.baseUrl + '/loyalty-target/get-point-config-template';

  //Reverse Points

  RedemptionReverseCash =
    this.baseUrl + '/rocaredemption/redemption-reverse-points';

  // All invoice api here ..
  getAllInvoice = this.baseUrl + '/invoice/get-all-invoices';
  getApproveInvoice = this.baseUrl + '/invoice/get-approved-invoices';
  getRejectInvoice = this.baseUrl + '/invoice/get-rejected-invoices';
  getPendingInvoice = this.baseUrl + '/invoice/get-pending-invoices';
  getProgramListInvoice = this.baseUrl + '/invoice/get-program-list';
  updateInvoiceUrl = this.baseUrl + '/invoice/update-invoice';
  approveInvoiceUrl = this.baseUrl + '/invoice/approve-invoice';
  rejectInvoiceUrl = this.baseUrl + '/invoice/reject-invoice';
  delProdInvoiceUrl = this.baseUrl + '/invoice/delete-invoice-product';
  srcInvoiceUrl = this.baseUrl + '/invoice/search-invoices';
  getOrderInvoiceUrl = this.baseUrl + '/invoice/get-invoice-orders';

  // Staff & Agent Panel

  // All ops-panel api here ..
  getRewardDropdown = this.baseUrl + '/ops-panel/get-rewards-dropdown';
  getDownOrderData = this.baseUrl + '/ops-panel/download-order-data';
  orderOfferCodeUp = this.baseUrl + '/ops-panel/order-offer-code-upload';
  orderOfferReject = this.baseUrl + '/ops-panel/reject-orders';
  resendOfferCode = this.baseUrl + '/ops-panel/resend-offercode-sms';
  uploadPhyRewardExl = this.baseUrl + '/ops-panel/order-physical-code-upload';
  getOfferCodeList = this.baseUrl + '/ops-panel/get-offercode-listings';

  // Staff & Agent Panel
  staff_Dashboard = this.baseUrl + '/staff/team-leader-dashboard';
  staff_invoce_trasection = this.baseUrl + '/staff/invoice-bulkassignlist';
  staff_enrollment = this.baseUrl + '/staff/entrollement-bulkassignlist';
  staff_unassign_count = this.baseUrl + '/staff/get-unassigned-invoice';
  engagement_unassign = this.baseUrl + '/staff/get-unassigned-engagement';
  enrollment_unassign = this.baseUrl + '/staff/get-unassigned-entrollement';
  agent_enrollment = this.baseUrl + '/staff/get-enrollement-list';
  get_user_details = this.baseUrl + '/users/get-userdetails?';

  getStaffEnagmentDashboard =
    this.baseUrl + '/staff/team-leader-enagement-dashboard';
  getStaffAllAgentDashboard = this.baseUrl + '/staff/pitcurebulkassignlist';
  PICTURE = this.baseUrl + '/staff/get-engagement-transactions';
  bulkAssignEnagement = this.baseUrl + '/staff/bulkassign';
  agentDashboard = this.baseUrl + '/staff/agent-dashboard';
  PICTURE_TEMPLATE = this.baseUrl + '/staff/get-picture-templates';
  PICTURE_APPROVE = this.baseUrl + '/staff/approvepicture';
  PICTURE_REJECT = this.baseUrl + '/staff/rejectpicture';
  agentInvoice = this.baseUrl + '/staff/get-invoice-transactions';
  agentApprovedInvoice = this.baseUrl + '/staff/get-approved-invoices-by-id';
  agentRejectedInvoice = this.baseUrl + '/staff/get-rejected-invoices-by-id';
  agentPendingInvoice = this.baseUrl + '/staff/get-pending-invoices-by-id';

  /**
   * Communication Matrix
   */
  get_basic_communication_matrix =
    this.baseUrl + '/communication-panel/get-communication-matrix';
  get_matrix_module_details =
    this.baseUrl + '/communication-panel/get-scenario-details?';
  update_communication_matrix =
    this.baseUrl + '/communication-panel/update-scenario-details';
  send_announcement =
    this.baseUrl + '/communication-panel/create-custom-notifications';
  getMatrixModulesDetails =
    this.baseUrl + '/communication-panel/get-scenario-detail?';
  triggerAdhocNotification =
    this.baseUrl + '/communication-panel/adhoc-push-notifications?';
  triggerEngageRemNotification =
    this.baseUrl +
    '/communication-panel/trigger-reminder-push-notification-for-engagement?';
  triggerTargetRemNotification =
    this.baseUrl +
    '/communication-panel/achievement-remainder-push-notifications?';
  triggerSchemeRemNotification =
    this.baseUrl + '/communication-panel/schemes-remainder-push-notifications?';

  // All ops-panel api of customer report here ..
  getUsrPointLedger = this.baseUrl + '/ops-panel/user-points-ledger';
  getDownPointLedger = this.baseUrl + '/ops-panel/download-points-ledger';

  //Privilege All APi
  getPrivilegeList = this.baseUrl + '/privilege/getprivileges?';
  uploadPrivilegeExcel = this.baseUrl + '/privilege/import-privileges';
  downloadPrivilegeExcel = this.baseUrl + '/privilege/download-privileges?';

  //Privilege Category
  getPrivilegeCatList =
    this.baseUrl + '/privilege-category/get-privilege-category?';
  createPrivilegeCat =
    this.baseUrl + '/privilege-category/create-privilege-category';
  editPrivilegeCat =
    this.baseUrl + '/privilege-category/update-privilege-category';
  deletePrivilegeCat =
    this.baseUrl + '/privilege-category/delete-privilege-category';

  //Privilege Booking
  getPrivilegeBookingList = this.baseUrl + '/privilege/getbookings?';
  updateBookingStatus = this.baseUrl + '/privilege/change-booking-status';
  getVenueDropDownList = this.baseUrl + '/privilege/getvenue?';
  downloadBookingExcel = this.baseUrl + '/privilege/download-bookingdata?';

  //delivery partner
  createdelPartner = this.baseUrl + '/delivery-partner/create-partner';
  editdelPartner = this.baseUrl + '/delivery-partner/update-partner';
  deletedelPartner = this.baseUrl + '/delivery-partner/delete-partner';

  //vendors
  getVendorsList = this.baseUrl + '/users/vendor-details';

  // All ops-panel api of points passbook here
  getUsrPassbook = this.baseUrl + '/ops-panel/points-passbook';
  getDownPassbook = this.baseUrl + '/ops-panel/download-passbook';

  uploadOrderDetails = this.baseUrl + '/ecommerce/import-order-details';
  checker_maker_bonous_points = this.baseUrl + '/loyalty-target/get-bonous?';
  create_communication_matrix =
    this.baseUrl + '/communication-panel/create-scenario';
  getTragetBrands = this.baseUrl + '/loyalty-target/get-brands-by-target';

  engagementUserAssignExcel =
    this.baseUrl + '/engagement/assign-user-task-excel';
  contentAndLearningUserAssignExcel =
    this.baseUrl + '/content-learning/assign-user-task-excel';
  getHeaders_based_modules = this.baseUrl + '/label/get-label?module_id=';
  create_update_module_headers = this.baseUrl + '/label/create-update-label';
  get_all_the_programs = this.baseUrl + '/programs/get-programs?id=';
  getTargetTypeDropdown = this.baseUrl + '/application-config/target-type';
  create_update_program = this.baseUrl + '/programs/create-update-programs';
  update_program_status = this.baseUrl + '/programs/delete-programs';
  update_login_program = this.baseUrl + '/login/update-program';
  download_orders_details =
    this.baseUrl + '/ecommerce/download-ecommerce-orders?';
  getEbrochure = this.baseUrl + '/brochure/get-brochure';
  createEbrochure = this.baseUrl + '/brochure/create-brochure';
  UpdateEbrochure = this.baseUrl + '/brochure/update-brochure';
  deleteEbrochure = this.baseUrl + '/brochure/delete-brochure';
  filterEbrochure = this.baseUrl + '/brochure/filter-brochure';

  //Added by Aarif Scan & Earn
  scanEarnListing = this.baseUrl + '/scan-earn/get-scan-earn';
  scanEarnCreate = this.baseUrl + '/scan-earn/create-scan-earn';
  uploadScanEarn = this.baseUrl + '/scan-earn/import-scan-earn';

  //Added by Aarif Beat mapping
  ImportBeatMapping = this.baseUrl + '/beats/import-beat-mapping';
  BeatMappingList = this.baseUrl + '/beats/beat-mapping-list?program_id=';
  BeatMappingUserList = this.baseUrl + '/beats/user-list?program_id=';
  AssignBeats = this.baseUrl + '/beats/assign-beats?program_id=';

  //push notification
  pushNotification =
    this.baseUrl + '/communication-panel/get-template-push-notification';
  moduleList = this.baseUrl + '/communication-panel/get-module-list';
  moduleListForReminderNoti =
    this.baseUrl + '/communication-panel/get-module-list-reminder?';
  sendTempleteNotification =
    this.baseUrl + '/communication-panel/update-template-push-notification';
  subModuleItemList = this.baseUrl + '/communication-panel/get-sub-item-list';
  getRemenderNotification =
    this.baseUrl + '/communication-panel/get-reminder-push-notification-list';
  addRemenderNotification =
    this.baseUrl +
    '/communication-panel/create-sub-item-reminder-notification-data';
  updateRemenderNotification =
    this.baseUrl +
    '/communication-panel/update-sub-item-reminder-notification-data';
  fieldList = this.baseUrl + '/communication-panel/get-scenario-details';
  adhocRole = this.baseUrl + '/communication-panel/get-role-list';
  adhocNotificationList =
    this.baseUrl + '/communication-panel/get-adhoc-push-notification-list';
  adhocuploadExcel =
    this.baseUrl + '/communication-panel/import-excel-adhoc-push-notification';
  addhocuploadrolewise =
    this.baseUrl +
    '/communication-panel/create-adhoc-push-notification-based-on-role';
  addhocFileld = this.baseUrl + '/communication-panel/get-select-field-details';
  addhocupdateNotification =
    this.baseUrl + '/communication-panel/update-adhoc-notification';

  //best Display Contest list
  addContest = this.baseUrl + '/contest/create-contest';
  getContest =
    this.baseUrl + '/contest/contest-general-details?contest_type_id=';
  getRewardDetails = this.baseUrl + '/engagement/get-reward-details';
  SaveDCC = this.baseUrl + '/engagement/display-contest-configuration';
  getConfigurationdetails =
    this.baseUrl + '/engagement/get-configuration-details?contest_id=';
  contestAssignUsers = this.baseUrl + '/contest/map-users';
  userAssigned = this.baseUrl + '/contest/download-user?contest_id=';

  //best Display config
  getConfigList = this.baseUrl + '/engagement/contest-general-details?';
  getSubmissionContest = this.baseUrl + '/engagement/get-submitted-contest?';
  getContestParam = this.baseUrl + '/engagement/get-contest-params?';
  rateSubmission = this.baseUrl + '/engagement/rate-submission';
  getLeadreBoardList = this.baseUrl + '/engagement/get-leaderboard-contest?';
  publishLeadreBoard = this.baseUrl + '/engagement/publish-leaderboard';
  contestUploadUser = this.baseUrl + '/contest/import-user';
  getContestLeg = this.baseUrl + '/engagement/get-contest-legs?';

  //Engagement  Poll Survey
  pollSurveyList = this.baseUrl + '/poll-survey/get-poll-survey?campain_type=';
  createUpdatePollSurvey =
    this.baseUrl + '/poll-survey/create-update-poll-survey';
  deletepollSurvey = this.baseUrl + '/poll-survey/delete-poll-survey?';
  getPollSurveyById =
    this.baseUrl + '/poll-survey/get-poll-survey-by-id?contest_id=';
  savePollSurveyPointReward =
    this.baseUrl + '/engagement/poll-survey-configuration?';
  getPollSurveyPointRewardDetails =
    this.baseUrl + '/engagement/get-configuration-details?contest_id=';

  //Highest Salec contest
  saveValueBased = this.baseUrl + '/contest/sales-contest-configuration';
  savePointsRewards = this.baseUrl + '/contest/contest-reward-config';
  getValueBasedDetails =
    this.baseUrl + '/contest/get-configuration?contest_id=';
  getPointRewardsDetails = this.baseUrl + '/contest/sales-rewards?contest_id=';
  getLeadreBoardListHSC = this.baseUrl + '/engagement/get-leaderboard-hsc?';
  publishLeadreBoardHSC = this.baseUrl + '/engagement/publish-leaderboard-hsc';

  //Shomphy Demo
  getBrandsInvoiceList = this.baseUrl + '/staff/get-invoice-lists?';
  brandApprovInvoice = this.baseUrl + '/invoice/invoice-approve';
  brandRejectInvoice = this.baseUrl + '/invoice/invoice-reject';
  getProductList = this.baseUrl + '/invoice/get-invoice-products?';
  runScheduler = 'http://api.billsnap.bigcityvoucher.co.in:6004/api/v1/apicall';

  //jaquar Agent Api
  get_user_EnrollList = this.baseUrl + '/users/get-userdetails';

  approveRejectEnrollment = this.baseUrl + '/users/approve-reject-enrollment';
  rejectedReasons = this.baseUrl + '/users/rejection-reasons';

  getTicketsList = this.baseUrl + '/visit-tracker/get-tickets';
  approveRejectTicket = this.baseUrl + '/visit-tracker/approve-reject-ticket';
  pointLedger = this.baseUrl + '/visit-tracker/get-points-ledger';
  checkOtp = this.baseUrl + '/visit-tracker/search-otp';
  getReasonList = this.baseUrl + '/visit-tracker/ticket-reasons?';
  getClientTicketsList = this.baseUrl + '/visit-tracker/get-tickets';
  approveRejectClientTicket =
    this.baseUrl + '/visit-tracker/client-approve-reject-ticket';
  searchBySerialCodes = this.baseUrl + '/visit-tracker/qr-status';
  transferPoints = this.baseUrl + '/visit-tracker/transfer-points';
  transferHistory = this.baseUrl + '/visit-tracker/transfered-tickets';
  // Entity
  entityExcelData = this.baseUrl + '/users/download-entity-excel';
  getEntityList = this.baseUrl + '/users/get-entity-data';
  importEntityExcel = this.baseUrl + '/users/import-entity';

  // rejectedReasons = this.baseUrl

  // Behaviour-Engagement
  getBehaviourTypes = this.baseUrl + '/behavior/getbehaviortype';
  createBehaviourEngagement = this.baseUrl + '/behavior/createbehaviorconfig';
  createCongfiguration = this.baseUrl + '/behavior/behaviorconfig';
  uploadUser = this.baseUrl + '/behavior/uploaduser';
  getAllBehaviourEngagements = this.baseUrl + '/behavior/getbehaviorconfig';

  // Spin The Wheel
  SpinWheel_Config = this.baseUrl + '/spin-wheel/spin-config';
  segment_config_list = this.baseUrl + '/spin-wheel/segment-config';
  SpinConfig_List = this.baseUrl + '/spin-wheel/list-spin-config';
  spin_Upoad_excel = this.baseUrl + '/spin-wheel/spin-structure-upload';
  downloadSpinStructure = this.baseUrl + '/spin-wheel/download-spin-structure';
  editSegementList = this.baseUrl + '/spin-wheel/edit-segment-config';
  rewardsList = this.baseUrl + '/spin-wheel/list-product';

  // settings
  getFAQs = this.baseUrl + '/programs/get-faq';
  CreateFAQs = this.baseUrl + '/programs/create-faq';
  updateFAQs = this.baseUrl + '/programs/update-faq';
  deleteFAQs = this.baseUrl + '/programs/delete-faq';
  getPrivacyPolicy = this.baseUrl + '/programs/get-privacy-policy';
  updatePrivacyPolicy = this.baseUrl + '/programs/update-privacy-policy';
  getTermsAndCondition = this.baseUrl + '/programs/get-terms-condition';
  updateTermsAndCondition = this.baseUrl + '/programs/update-terms-condition';

  // Points Structure
  // createPointsStructure = this.baseUrl + "/loyalty-target/create-point-config-template";
  // getPointsStructure = this.baseUrl + "/loyalty-target/get-point-config-template";

  // New Targets and Achiements
  getTargets = this.baseUrl + '/loyalty-target/get-target';
  CreateTargets = this.baseUrl + '/loyalty-target/create-target';
  updateTargets = this.baseUrl + '/loyalty-target/update-target';
  getQuater = this.baseUrl + '/frequency/get-quarter';
  getCycle = this.baseUrl + '/frequency/get-cycle';
  assign_Target_PointStructure =
    this.baseUrl + '/loyalty-target/point-structure';
  // getTargetImports = this.baseUrl + "/loyalty-target/get-target-import";
  // getPointStructureOnID = this.baseUrl + "/loyalty-target/get-pointstructure";
  // uploadAchievements = this.baseUrl + `/loyalty-target/import-achievement?${this.params}`;
  // generateMakerCheckerReport = this.baseUrl + "/loyalty-target/maker-checker";
  // generatedReportsList = this.baseUrl + "/loyalty-target/list-maker-check";

  //Quarter

  configGetQuarter = this.baseUrl + '/frequency/get-quarter';
  configAddQuarter = this.baseUrl + '/frequency/create-quarter';
  configEditQuarter = this.baseUrl + '/frequency/update-quarter';
  configDeleteQuarter = this.baseUrl + '/frequency/delete-quarter';

  //Cycle
  configGetCycle = this.baseUrl + '/frequency/get-cycle';
  configAddCycle = this.baseUrl + '/frequency/create-cycle';
  configEditCycle = this.baseUrl + '/frequency/update-cycle';
  configDeleteCycle = this.baseUrl + '/frequency/delete-cycle';

  //QrConfiguration

  approveQrConfig = this.baseUrl + '/qr/generateqrcodes';
  qrConfig = this.baseUrl + '/qr/qrconfig';
  geQrConfig = this.baseUrl + '/qr/getqrconfig';
  generateQr = this.baseUrl + '/qr/genereate-qr';
  getQrLIst = this.baseUrl + '/qr/getqrrequestlist';
  qrImportConfig = this.baseUrl + '/qr/importqrcodes';

  // Engagement
  whiteListEngagementUser = this.baseUrl + '/engagement/whitelist-engagement';
  engagementList = this.baseUrl + '/engagement/list-engagement';
  getCampaignOnid = this.baseUrl + '/userdetails/get-campaign-list';
  getAllListOfCampaign = this.baseUrl + '/userdetails/get-all-campaign';
  viewEngagementDetail = this.baseUrl + '/engagement/view-engagement';
  createContentAndLarning =
    this.baseUrl + '/engagement/create-engagement-content';
  engagementTypes = this.baseUrl + '/engagement/engagementtypes';
  engagementElement = this.baseUrl + '/engagement/engagementelementtypes';
  createImageEngagement = this.baseUrl + '/engagement/create-engagement';
  engagemetnWhitelistUser = this.baseUrl + '/engagement/user-whitelisted';
  deactiveEnagegementUser = this.baseUrl + '/engagement/deactivate-whitelist';
  uploadInstructionImage =
    this.baseUrl + '/engagement/upload-instruction-image';
  createEngagementQuiz = this.baseUrl + '/engagement/create-engagement-content';
  getAssigned_users = this.baseUrl + '/engagement/user-whitelisted';
  disableEngagement = this.baseUrl + '/engagement/disable-engagement';
  getEngagementTemplateDetail = this.baseUrl + '/engagement/elementdata';

  getEngagementTemplateById =
    this.baseUrl + '/engagement/get-picture-template?task_id=';
  getEngagementById = this.baseUrl + '/engagement/get-engagements?id=';

  setQuizCreationCompleteForcampaign =
    this.baseUrl + '/engagement/set-quiz-creation-complete-forcampaign';
  pointCalcEngagement = this.baseUrl + '/engagement/calculate-points';
  getBranchs = this.baseUrl + '/users/get-branch';
  getTiers = this.baseUrl + '/users/get-program-tier';
  getChannels = this.baseUrl + '/users/get-channels';

  //Reporting panel

  enrollment_report = this.baseUrl + '/report-dashboard/enrollment-report';
  summary_report = this.baseUrl + '/report-dashboard/summary-report';
  merchandiseredemptionreport =
    this.baseUrl + '/report-dashboard/merchandise-redemption-report';
  cumulative_points_report =
    this.baseUrl + '/report-dashboard/point-accumulation-report';
  user_hierarchy_report =
    this.baseUrl + '/report-dashboard/user-hierarchy-report';
  targetAndAchievementReport =
    this.baseUrl + '/report-dashboard/target-and-achievement-report';
  salesAchievementReport =
    this.baseUrl + '/report-dashboard/sales-achievement-report';
  userChangesReport = this.baseUrl + '/report-dashboard/user-changes-report';
  rolewiseUserReport = this.baseUrl + '/report-dashboard/rolewise-users-report';
  dsrEnrollmentReport =
    this.baseUrl + '/report-dashboard/dsr-enrollment-report';
  reportlogin = this.baseUrl + '/report-dashboard/login-report';
  targetandachievementquarterlyreport =
    this.baseUrl + '/report-dashboard/target-and-achievement-quarterly-report';
  egvredemptionreport =
    this.baseUrl + '/report-dashboard/egv-redemption-report';
  pointsreconciliationreport =
    this.baseUrl + '/report-dashboard/points-reconciliation-report';

  getPrortfolio = this.baseUrl + '/users/get-portfolio';

  changeUser = this.baseUrl + '/users/import-hierarchy-changes';


  getUserPointSummary = this.baseUrl + '/report/user-point-summary-report?program_id=1';


  // Change SuperVisor Heirrachy
  SupervisorSwap = this.baseUrl + '/users/supervisor-swap';

  // Supervisor Swap
  supervisorSplitAssign = this.baseUrl + '/users/supervisor-splitand-assign';

  // User-super-visor-mapping
  getUserHeirachyExcelHeaders =
    this.baseUrl + '/users/download-hierarchy-excel';
  downloadUserHierachyexcel = this.baseUrl + '/users/get-import-hierarchy';
  // Inactive Users
  getHierracryUserList = this.baseUrl + '/users/get-hierarchy-id-details';
  inactiveHierracy = this.baseUrl + '/users/inactivate-hierarchy';
  getPortfolioDetails = this.baseUrl + 'users/get-portfolio';

  getAdharPanData = this.baseUrl + '/visit-tracker/get-pandata?';
  resetAdharPanData = this.baseUrl + '/visit-tracker/reset-pandata?';

  // Ad Hoc Points
  uploadAdHocPoints = this.baseUrl + '/hubadmin/upload-adhoc-points';
  getAdHocList = this.baseUrl + '/hubadmin/list-adhoc-points';
  approveAdHoc = this.baseUrl + '/hubadmin/approve-adhoc-points';
  rejectAdHoc = this.baseUrl + '/hubadmin/reject-adhoc-points';

  getRewardSubCategory =
    this.baseUrl + '/rewards/get-reward-sub-categories&reward_category_id=';
  getRewardsBrands =
    this.baseUrl + '/rewards/get-reward-category-brands&reward_category_id=';

  //Channels
  configGetChannel = this.baseUrl + '/channels/get-channel';
  configAddChannel = this.baseUrl + '/channels/create-channel';
  configEditChannel = this.baseUrl + '/channels/update-channel';
  configDeleteChannel = this.baseUrl + '/channels/delete-channel';

  // Languages
  configGetLanguages = this.baseUrl + '/language/get-languages';
  configAddLanguage = this.baseUrl + '/language/create-language';
  configEditLanguage = this.baseUrl + '/language/update-language';
  configDeleteLanguage = this.baseUrl + '/language/delete-language';

  // Frequency
  configGetFrequency = this.baseUrl + '/frequency/get-frequency';
  configAddFrequency = this.baseUrl + '/frequency/create-frequency';
  configEditFrequency = this.baseUrl + '/frequency/update-frequency';

  //Cities
  configGetCities = this.baseUrl + '/city/get-city';
  configAddCity = this.baseUrl + '/city/create-city';
  configEditCity = this.baseUrl + '/city/update-city';
  configDeleteCity = this.baseUrl + '/city/delete-city';
  importExcelCity = this.baseUrl + '/city/import-city';

  //Bannres
  bannersList = this.baseUrl + '/banner/get-banner';
  createBanner = this.baseUrl + '/banner/create-banner?';
  updateBanner = this.baseUrl + '/banner/update-banner?';
  deleteBanner = this.baseUrl + '/banner/delete-banner?';
  getportfolio = this.baseUrl + '/users/get-portfolio?program_id=3';

  // Region
  configGetRegion = this.baseUrl + '/region/get-region';
  configAddRegion = this.baseUrl + '/region/create-region';
  configUpdateRegion = this.baseUrl + '/region/update-region';
  configDeleteRegion = this.baseUrl + '/region/delete-region';
  importExcelRegion = this.baseUrl + '/region/import-region';
  userPointSummary = this.baseUrl + '/staff/get-user-points?id=';

  //states
  configAddState = this.baseUrl + '/state/create-state';
  configEditState = this.baseUrl + '/state/update-state';
  configDeleteState = this.baseUrl + '/state/delete-state';
  importExcelState = this.baseUrl + '/state/import-state';

  getRedemptiondetailss = this.baseUrl + '/redemption/failure-order-data';
  getSucessRedemptiondetails = this.baseUrl + '/redemption/success-order-data';

  //concierge
  getUserDetails = this.baseUrl + '/hubadmin/userdetails?program_id=1';
  getLedgerDetails = this.baseUrl + '/hubadmin/user-ledger?program_id=1';


  //Filter data, regions,states.cities,channel,roles, geography
}
export interface ApiConfigurationInterface {}
